import config from "config.json";
import { getCookieValue, getGeolocationCookieData } from "utils/cookie";

export const loadAffiliationsFromCookies = (
	brand,
	affiliationsCookie = null,
	geolocationCookie = null
) => {
	let affiliationsToAdd = [];
	try {
		const affiliationsFromCookie = getCookieValue(
			affiliationsCookie,
			config.cookies.affiliations
		);
		if (affiliationsFromCookie) {
			affiliationsToAdd = affiliationsFromCookie?.[brand]?.multiAffls?.length
				? affiliationsFromCookie?.[brand]?.multiAffls
				: affiliationsFromCookie?.[brand]?.storedAffiliations ||
				  affiliationsFromCookie?.storedAffiliations ||
				  [];
		}
	} catch (error) {
		console.error(error);
	}

	try {
		if (
			config.brands[brand].preventReadingGeoCookieWhenLoadedAffiliations &&
			affiliationsToAdd?.length
		) {
			return affiliationsToAdd;
		}
		const affiliationsFromGeolocation = getGeolocationCookieData(
			geolocationCookie,
			config.cookies.geolocation
		);
		const {
			region = "",
			country = "",
			zipCodes = "",
		} = affiliationsFromGeolocation;
		if (country) {
			if (config.affiliations.country[country]) {
				affiliationsToAdd.push(config.affiliations.country[country]);
			}
		}
		if (config.affiliations.region[region]) {
			affiliationsToAdd.push(config.affiliations.region[region]);
		}
		if (zipCodes) {
			let zipCodeAffiliation = null;
			for (
				let index = 0;
				index < Object.keys(config.affiliations.zipCode).length &&
				!zipCodeAffiliation;
				index++
			) {
				const range = Object.keys(config.affiliations.zipCode)[index].split(
					"_"
				);
				for (
					let zipCodeIndex = 0;
					zipCodeIndex < zipCodes.length && !zipCodeAffiliation;
					zipCodeIndex++
				) {
					if (
						zipCodes[zipCodeIndex] >= range[0] &&
						zipCodes[zipCodeIndex] <= range[1]
					) {
						zipCodeAffiliation =
							config.affiliations.zipCode[
								Object.keys(config.affiliations.zipCode)[index]
							];
					}
				}
			}
			if (zipCodeAffiliation) {
				affiliationsToAdd.push(zipCodeAffiliation);
			}
		}
	} catch (error) {
		console.error(error);
	}
	return affiliationsToAdd;
};

export const validateItemAffiliations = (item = {}, affiliations = []) => {
	if (
		item.affiliation?.length &&
		(!affiliations.length ||
			!affiliations.some((affiliation) =>
				item.affiliation.includes(affiliation)
			))
	) {
		return false;
	}

	if (
		item.affiliationExclusion?.length &&
		affiliations.length &&
		affiliations.some((affiliation) =>
			item.affiliationExclusion.includes(affiliation)
		)
	) {
		return false;
	}

	return true;
};
